import { FormControl } from '@chakra-ui/form-control';
import { Box, Button, Flex } from '@chakra-ui/react';
import { Select } from '@chakra-ui/select';
import { Domicile } from '@services/appsync/types';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../../config';
import { CreateAccountForm } from '../types';
import { PageHeader } from './components/PageHeader';
import { UI } from './components/UI';

type CitizenshipProps = {
  form: UseFormReturn<CreateAccountForm>;
};

export const Citizenship: React.FC<CitizenshipProps> = ({ form }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  const redirectAsParam = redirect ? `?redirect=${encodeURIComponent(redirect)}` : '';

  const onSubmit = () => {
    navigate(ROUTES.createAddress + redirectAsParam);
  };

  return (
    <UI>
      <Flex px={[6, 20]} pt={['24px', '56px']} pb={[20, 200]} direction={'column'} gap={10} align="center">
        <PageHeader
          title="Complete your investor profile"
          subtitle="We just need a few details to get your investor profile completed"
          step={1}
          steps={3}
        />
        <Box as="form" onSubmit={onSubmit} minW={['100%', '350px']}>
          <FormControl margin="auto">
            <Select
              autoFocus={true}
              maxW={['full', 350]}
              mb={3}
              placeholder="Select option"
              defaultValue={form.getValues().citizenship || Domicile.USC}
              {...form.register('citizenship', {
                required: 'Please enter a state',
              })}>
              <option value={Domicile.USC}>I am a US Citizen</option>
              <option value={Domicile.USR}>I am a US Resident</option>
            </Select>
          </FormControl>
          <Box>
            <Button type="submit" w="full" p={7}>
              Continue
            </Button>
          </Box>
        </Box>
      </Flex>
    </UI>
  );
};
